import React, { memo, useContext, useEffect, useMemo } from 'react';

import styles from './AccountDetails.module.scss';
import classNames from 'classnames/bind';
import { BsFillCircleFill } from '@react-icons/all-files/bs/BsFillCircleFill';
import { ServiceOptions } from '../../../constants/serviceKit';
import { useStore } from '../../../hooks/use-store';
import {useCustomerServiceDashboardStore} from "../../store";

const classes = classNames.bind(styles);
export interface AccountDetailsProps {
    accountNumber: string;
    accountDetails: Mri.Accounts.Account;
    className?: string; // Add className prop
}

enum ServiceLevelSortOrder {
    SmartVuPlatinum = 0,
    SmartVuGold = 1,
    MRIStandardWarranty = 2,
    SmartVuCustom = 3,
    SmartVuPortal = 4,
    Warranty = 5,
    OutOfWarranty = 6,
}

interface AccountDetailsContract extends Mri.Contracts.Contract {
    serviceOptionName?: string;
}

export const AccountDetails = ({ accountNumber, accountDetails, className }: AccountDetailsProps) => {
    const {fetchMonitoringLogsByAccountKey, selectContract, fetchAccountContracts, accountContracts } = useCustomerServiceDashboardStore();
    // const { contractsStore } = useStore();
    const contracts = accountContracts[accountNumber];
    const [loading, setLoading] = React.useState(false);
    const isMounted = React.useRef(true);
    const sortedContracts = useMemo(() => {
        if (!contracts) return [];

        // Mapping between ServiceLevel and ServiceLevelSortOrder
        const serviceLevelToSortOrder: { [key in Mri.Contracts.ServiceLevel]?: ServiceLevelSortOrder } = {
            [Mri.Contracts.ServiceLevel.SmartVuPlatinum]: ServiceLevelSortOrder.SmartVuPlatinum,
            [Mri.Contracts.ServiceLevel.SmartVuGold]: ServiceLevelSortOrder.SmartVuGold,
            [Mri.Contracts.ServiceLevel.MRIStandardWarranty]: ServiceLevelSortOrder.MRIStandardWarranty,
            [Mri.Contracts.ServiceLevel.SmartVuCustom]: ServiceLevelSortOrder.SmartVuCustom,
            [Mri.Contracts.ServiceLevel.SmartVuPortal]: ServiceLevelSortOrder.SmartVuPortal,
            [Mri.Contracts.ServiceLevel.Warranty]: ServiceLevelSortOrder.Warranty,
            [Mri.Contracts.ServiceLevel.OutOfWarranty]: ServiceLevelSortOrder.OutOfWarranty,
        };

        // Sort contracts by ServiceLevelSortOrder
        // const sorted = contracts.sort(
        //     (a: { serviceLevel: string | number }, b: { serviceLevel: string | number }) => {
        //         const aSortOrder = ServiceLevelSortOrder[a.serviceLevel as number];
        //         const bSortOrder = ServiceLevelSortOrder[b.serviceLevel as number];
        //         if (aSortOrder < bSortOrder) return -1;
        //         if (aSortOrder > bSortOrder) return 1;
        //         return 0;
        //     }
        // );
        const sorted = contracts;

        // Remove items with "active = false" from the sorted array
        const filtered = sorted.filter((item: { active: boolean }) => item.active !== false);
        // Append the filtered items to the end of the sorted array
        const finalSorted = [...filtered, ...sorted.filter((item: { active: boolean }) => item.active === false)];
        // Add the "serviceOptionName" value to each object
        const contractsWithServiceOptionName = finalSorted.map((contract: AccountDetailsContract) => {
            const serviceOption = ServiceOptions.find(option => option.value === contract.serviceLevel);
            const serviceOptionName = serviceOption ? serviceOption.option : '';
            return { ...contract, serviceOptionName };
        });

        return contractsWithServiceOptionName;
    }, [contracts]);
    

    useEffect(() => {
        fetchAccountContracts(accountNumber);
    }, [fetchAccountContracts, accountNumber]);

    interface ContractProps {
        contracts: AccountDetailsContract[];
    }
    const Contracts = ({ contracts }: ContractProps) => {
        const counts = [];
        return (
            <>
                {contracts.map((contract: AccountDetailsContract) => (
                    <div
                        className={classes('contract')}
                        key={`contract-${contract.serviceCO}`}
                        onClick={() => selectContract(contract)}
                    >
                        <BsFillCircleFill color={contract.active ? 'green' : 'red'} />
                        <div className={classes('service-co', 'btn', 'btn-link')}>{contract.serviceCO}</div>
                        <div className={classes('service-level')}>{contract.serviceOptionName}</div>
                        {/* {counts && counts.length && (
                            <ul className={classes('counts')}>
                                <li>{counts[0]}</li>
                                <li>{counts[1]}</li>
                                <li>{counts[2]}</li>
                            </ul>
                        )} */}
                    </div>
                ))}
            </>
        );
    };
    return (
        <div className={classes('account-details')}>
            {loading && <div>Loading...</div>}
            <div className={classes('contracts')}>
                Contracts
                {!loading && sortedContracts && sortedContracts.length > 0 && <Contracts contracts={sortedContracts} />}
            </div>
        </div>
    );
};
